import React, { useEffect, useRef, useState } from 'react';
import './Recruit.css';
import Text from '../common/Text.js'

const RecruitInputs = ({id, addJobBtnClick, delJobBtnClick, onSubmit, mode, eJob, ePerNo, eType, eTask, eReqShort, eReqLong, ePrefShort, ePrefLong,  }) => {

    const [paramStrings, setParamStrings] = useState([]);
    const [job, setJob] = useState(''); // 채용직무
    const [perNo, setPerNo] = useState(''); // 채용인원
    const [jobType, setJobType] = useState(''); // 채용유형

    //신규모드에서 관리하는 항목들
    const [tasks, setTasks] = useState(['']); // 담당업무
    const [requiredShort, setRequiredShort] = useState(['']); // 지원자격(간단히)
    const [requiredLong, setRequiredLong] = useState(['']); // 지원자격(자세히)
    const [preferredShort, setPreferredShort] = useState(['']); // 우대조건(간단히)
    const [preferredLong, setPreferredLong] = useState(['']); // 우대조건(자세히)
    const [isNumInputClicked, setIsNumInputClicked] = useState(false); //인원 input placeHolder

    //수정모드일 때 ;로 split 해서 관리하는 항목들
    const [splitTask, setSplitTask] = useState([]);  //담당업무
    const [splitReqShort, setSplitReqShort] = useState([]);  //지원자격(간단히)
    const [splitReqLong, setSplitReqLong] = useState([]);  //지원자격(자세히)
    const [splitPrefShort, setSplitPrefShort] = useState([]);  //우대조건(간단히)
    const [splitPrefLong, setSplitPrefLong] = useState([]);  //우대조건(자세히)
    

    //수정모드일 때 입력수정을 위한 항목들
    const refEjob = useRef('');
    const refEperNo = useRef('');
    const refEtype = useRef('');
    const refTask = useRef('');
    const refReqShort = useRef('');
    const refReqLong = useRef('');
    const refPrefShort = useRef('');
    const refPrefLong = useRef('');
    

    let strings = [
        {
            job: "",
            perNo: "",
            jobType: "",
            task: "",
            qualSh: "",
            qualL: "",
            prefSh: "",
            prefL: ""
        }
    ]

    useEffect(() => {
        if(mode && mode === 'edit') {

            //채용직무
            if(eJob !== refEjob.current) {
                setJob(eJob);
                refEjob.current = eJob;
            }

            //채용인원
            if(ePerNo !== refEperNo.current) {
                setPerNo(ePerNo);
                refEperNo.current = ePerNo;
            }

            //채용유형
            if(eType !== refEtype.current) {
                setJobType(eType);
                refEtype.current = eType;
            }

            //담당업무
            if(eTask !== refTask.current) {
                if(eTask) {
                    const newSplit = eTask.split(';');
                    setSplitTask(newSplit);
                } else {
                    setSplitTask([]);
                }
                setTasks(eTask)  //task 의 useState 변경
                refTask.current = eTask;
            }

            //지원자격 간단히
            if(eReqShort !== refReqShort.current) {
                if(eReqShort) {
                    const newSplit = eReqShort.split(';');
                    setSplitReqShort(newSplit);
                } else {
                    setSplitReqShort([]);
                }
                setRequiredShort(eReqShort)  //task 의 useState 변경
                refReqShort.current = eReqShort;
            }

            //지원자격 자세히
            if(eReqLong !== refReqLong.current) {
                if(eReqLong) {
                    const newSplit = eReqLong.split(';');
                    setSplitReqLong(newSplit);
                } else {
                    setSplitReqLong([]);
                }
                setRequiredLong(eReqLong)  //task 의 useState 변경
                refReqLong.current = eReqLong;
            }

            //우대조건 간단히
            if(ePrefShort !== refPrefShort.current) {
                if(ePrefShort) {
                    const newSplit = ePrefShort.split(';');
                    setSplitPrefShort(newSplit);
                } else {
                    setSplitPrefShort([]);
                }
                setPreferredShort(ePrefShort)  //task 의 useState 변경
                refPrefShort.current = ePrefShort;
            }

            //우대조건 자세히
            if(ePrefLong !== refPrefLong.current) {
                if(ePrefLong) {
                    const newSplit = ePrefLong.split(';');
                    setSplitPrefLong(newSplit);
                } else {
                    setSplitPrefLong([]);
                }
                setPreferredLong(ePrefLong)  //task 의 useState 변경
                refPrefLong.current = ePrefLong;
            }
            
        } 
        else if (mode && mode === 'new') {
            setTasks(['']);
            setRequiredShort(['']);
            setRequiredLong(['']);
            setPreferredShort(['']);
            setPreferredLong(['']);
        }
    }, [eTask])
    
    //Input 입력 이벤트 - 직무,인원,유형
    const handleInputChange =(setter) => (event) => {
        setter(event.target.value);
    };

    //Input 입력 이벤트 - 복수항목
    const handleInputListChange = (setter) => (index) => (event) => {
        const newArray = setter((prev) => {
            const updatedArray = [...prev]; // 현재 상태를 복사
            updatedArray[index] = event.target.value; // 해당 인덱스의 값을 업데이트
            return updatedArray; // 업데이트된 배열을 반환
        });
    };

    // 추가버튼 이벤트
    const addInputField = (setter) => {
        setter((prev) => [...prev, '']); 
    };

    // 삭제버튼 이벤트
    const handleRemoveItem = (category, index) => {
        if(category === 'type') {
            const newJobType = jobType.filter((_, i) => i !== index); 
            setJobType(newJobType);
        }

        //담당업무
        else if(category === 'task') {
            if(mode === 'new') {
                const delVal = tasks.filter((_, i) => i !== index); 
                setTasks(delVal);
            } else if (mode === 'edit') {
                const delVal = splitTask.filter((_, i) => i !== index); 
                setSplitTask(delVal);
            }
        }

        //지원자격 간단히
        else if(category === 'qualShort') {
            if(mode === 'new') {
                const delVal = requiredShort.filter((_, i) => i !== index); 
                setRequiredShort(delVal);
            } else if (mode === 'edit') {
                const delVal = splitReqShort.filter((_, i) => i !== index); 
                setSplitReqShort(delVal);
            }
            
        }

        //지원자격 자세히
        else if(category === 'qualLong') {
            if(mode === 'new') {
                const delVal = requiredLong.filter((_, i) => i !== index); 
                setRequiredLong(delVal);
            } else if (mode === 'edit') {
                const delVal = splitReqLong.filter((_, i) => i !== index); 
                setSplitReqLong(delVal);
            }
        }

        //우대조건 간단히
        else if(category === 'prefShort') {
            if(mode === 'new') {
                const delVal = preferredShort.filter((_, i) => i !== index); 
                setPreferredShort(delVal);
            } else if (mode === 'edit') {
                const delVal = splitPrefShort.filter((_, i) => i !== index); 
                setSplitPrefShort(delVal);
            }
        }

        //우대조건 자세히
        else if(category === 'prefLong') {
            if(mode === 'new') {
                const delVal = preferredLong.filter((_, i) => i !== index); 
                setPreferredLong(delVal);
            } else if (mode === 'edit') {
                const delVal = splitPrefLong.filter((_, i) => i !== index); 
                setSplitPrefLong(delVal);
            }
        }
      };

    const handleSubmit = (event) => {
        event.preventDefault();

        let resultTask = '';
        let resultReqShort = '';
        let resultReqLong = '';
        let resultPrefShort = '';
        let resultPrefLong = '';

        if(mode === 'new') {
            resultTask = tasks.join(';');
            resultReqShort = requiredShort.join(';');
            resultReqLong = requiredLong.join(';');
            resultPrefShort = preferredShort.join(';');
            resultPrefLong = preferredLong.join(';');
        } else if (mode === 'edit') {
            resultTask = splitTask.join(';');
            resultReqShort = splitReqShort.join(';');
            resultReqLong = splitReqLong.join(';');
            resultPrefShort = splitPrefShort.join(';');
            resultPrefLong = splitPrefLong.join(';');
            
        }

        console.log('채용직무:', job);
        console.log('채용인원:', perNo);
        console.log('채용유형:', jobType);
        console.log('담당업무:', resultTask);
        console.log('지원자격(간단히):', resultReqShort);
        console.log('지원자격(자세히):', resultReqLong);
        console.log('우대조건(간단히):', resultPrefShort);
        console.log('우대조건(자세히):', resultPrefLong);
                
        if(job == '' ||
            perNo == '' ||
            jobType == '' ||
            resultTask == '' ||
            resultReqShort == '' ||
            resultReqLong == '' ||
            resultPrefShort == '' ||
            resultPrefLong == '') {
                alert("입력되지 않은 값이 있습니다.");

                return;
        }

        
        strings.job = job;
        strings.perNo = perNo;
        strings.jobType= jobType;
        strings.task = resultTask;
        strings.qualSh = resultReqShort;
        strings.qualL = resultReqLong;
        strings.prefSh = resultPrefShort;
        strings.prefL = resultPrefLong;

        alert("입력값이 적용되었습니다.")
        onSubmit(strings);
    };


    return (
        <form onSubmit={handleSubmit}>
            {/* 채용직무 */}
            <div className='input-wrapper'>
                <Text variant="px20w600">채용직무</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    <input
                        type="text"
                        value={job}
                        onChange={handleInputChange(setJob)}
                        style={{ paddingRight: '40px', width: '200px' }} 
                        disabled={mode === 'edit'}
                        >
                    </input>
                </div>
            </div>

            <div className='input-wrapper'>
                <Text variant="px20w600">채용인원</Text>
                    <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                        <input
                            type="text"
                            value={perNo}
                            onChange={handleInputChange(setPerNo)}
                            style={{ paddingRight: '40px', width: '200px' }} 
                            onFocus={() => {
                                setIsNumInputClicked(true);
                            }}
                            onBlur={() => {
                                setIsNumInputClicked(false);
                            }}
                            placeholder={isNumInputClicked === true ? "" : "숫자만 입력"}
                            >
                        </input>
                    </div>
            </div>

            {/* 채용유형 */}
            <div className='input-wrapper'>
                <Text variant="px20w600">채용유형</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                        <input
                        type="text"
                        value={jobType}
                        onChange={handleInputChange(setJobType)}
                        style={{ paddingRight: '40px', width: '200px' }} 

                        >
                    </input>
                    {/* 다수 항목 입력 버전 */}
                    {/* {jobType.map((type, index) => (
                        <div className='div-wrapper' key={index}>
                            <input
                                key={index}
                                type="text"
                                value={type}
                                onChange={handleInputListChange(setJobType)(index)}
                                style={{ paddingRight: '40px', width: '200px' }} 
                            />
                            <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('type', index)}>
                                <Text variant="px14R" >삭제</Text>
                            </button>
                        </div>
                        ))
                        }
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setJobType)}>추가</button> */}

                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}
            {/* 담당업무 */}
            <div className='input-wrapper'>
                <Text variant="px20w600">담당업무</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    {mode === 'new' && tasks && (
                        tasks.map((task, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={task}
                                    onChange={handleInputListChange(setTasks)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('task', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {mode === 'edit' && splitTask && (
                        splitTask.map((task, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={task}
                                    onChange={handleInputListChange(setSplitTask)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('task', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>                                
                        </div>
                        ))

                    )} 
                    {/* 추가버튼은 map을 돌지 않고 마지막에 한번만 */}
                    {mode !== 'edit' && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setTasks)}>추가</button>
                    )}
                    {mode === 'edit' && splitTask && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setSplitTask)}>추가</button>
                    )}
                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}
            {/* 지원자격 (간단히) */}
            <div className='input-wrapper'>
                <Text variant="px20w600">지원자격</Text>
                <Text variant="px16"> (간단히 16자 이내)</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    {mode === 'new' && requiredShort && (
                        requiredShort.map((required, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={required}
                                    onChange={handleInputListChange(setRequiredShort)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('qualShort', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {mode === 'edit' && splitReqShort && (
                        splitReqShort.map((required, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={required}
                                    onChange={handleInputListChange(setSplitReqShort)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('qualShort', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {/* 추가버튼은 map을 돌지 않고 마지막에 한번만 */}
                    {mode === 'new' && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setRequiredShort)}>추가</button>
                    )}
                    {mode === 'edit' && splitReqShort && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setSplitReqShort)}>추가</button>
                    )}
                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}
            {/* 지원자격 (자세히) */}
            <div className='input-wrapper'>
                <Text variant="px20w600">지원자격</Text>
                <Text variant="px16"> (자세히)</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    {mode === 'new' && requiredLong && (
                        requiredLong.map((required, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={required}
                                    onChange={handleInputListChange(setRequiredLong)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('qualLong', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {mode === 'edit' && splitReqLong && (
                        splitReqLong.map((required, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={required}
                                    onChange={handleInputListChange(setSplitReqLong)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('qualLong', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {/* 추가버튼은 map을 돌지 않고 마지막에 한번만 */}
                    {mode === 'new' && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setRequiredLong)}>추가</button>
                    )}
                    {mode === 'edit' && splitReqLong && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setSplitReqLong)}>추가</button>
                    )}
                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}
            {/* 우대조건 (간단히) */}
            <div className='input-wrapper'>
                <Text variant="px20w600">우대조건</Text>
                <Text variant="px16"> (간단히 16자 이내)</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    {mode === 'new' && preferredShort && (
                       preferredShort.map((preference, index) => (
                        <div className='div-wrapper' key={index}>
                            <input
                                key={index}
                                type="text"
                                value={preference}
                                onChange={handleInputListChange(setPreferredShort)(index)}
                                style={{ paddingRight: '40px', width: '200px' }} 
                            />
                            <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('prefShort', index)}>
                                <Text variant="px14R" >삭제</Text>
                            </button>
                        </div>
                        )) 
                    )}
                    {mode === 'edit' && splitPrefShort && (
                        splitPrefShort.map((preference, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={preference}
                                    onChange={handleInputListChange(setSplitPrefShort)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('prefShort', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            )) 
                    )}
                    {/* 추가버튼은 map을 돌지 않고 마지막에 한번만 */}
                    {mode === 'new' && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setPreferredShort)}>추가</button>
                    )}
                    {mode === 'edit' && splitPrefShort && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setSplitPrefShort)}>추가</button>
                    )}
                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}
            {/* 우대조건 (자세히) */}
            <div className='input-wrapper'>
                <Text variant="px20w600">우대조건</Text>
                <Text variant="px16"> (자세히)</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
                    {mode === 'new' && preferredLong && (
                        preferredLong.map((preference, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={preference}
                                    onChange={handleInputListChange(setPreferredLong)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('prefLong', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {mode === 'edit' && splitPrefLong && (
                        splitPrefLong.map((preference, index) => (
                            <div className='div-wrapper' key={index}>
                                <input
                                    key={index}
                                    type="text"
                                    value={preference}
                                    onChange={handleInputListChange(setSplitPrefLong)(index)}
                                    style={{ paddingRight: '40px', width: '200px' }} 
                                />
                                <button className='btnInputDel' type="button" onClick={() => handleRemoveItem('prefLong', index)}>
                                    <Text variant="px14R" >삭제</Text>
                                </button>
                            </div>
                            ))
                    )}
                    {mode === 'new' && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setPreferredLong)}>추가</button>
                    )}
                    {mode === 'edit' && splitPrefLong && (
                        <button className='btnInputAdd' type="button" onClick={() => addInputField(setSplitPrefLong)}>추가</button>
                    )}
                </div>
            </div>
            {/* ----------------------------------------------------------------------- */}

            <button className='btnInputSave' type="submit" >입력완료</button>
            {/* <button className='btnInputSave' type="button" name={eJob} onClick={(event) => delJobBtnClick(event.target.name)} >직무삭제</button> */}
            <button className='btnInputSave' type="button" onClick={() => delJobBtnClick(id, eJob)} >직무삭제</button>


            {mode && mode === 'new' && (
                <>
                    <button className='btnInputSave' type="button" onClick={addJobBtnClick} >직무추가</button>
                </>
            )}


        </form>
    );
};

export default RecruitInputs;